import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getNettoMarkUps({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_NETTO_MARK_UPS_REQUEST')

        return axios
            .get(`/finances/margins${paginate}${query}`)
            .then(response => {
                commit('GET_NETTO_MARK_UPS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_NETTO_MARK_UPS_FAILURE')
                handleApiError(error, 'Pobranie narzutów netto nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateNettoMarkUp({ commit }, payload) {
        return axios
            .put(`/finances/margins/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Narzut netto został zaktualizowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja narzutu netto nie powiodła się.')

                return Promise.reject(error)
            })
    },
    setProductGroupFactorsFilters({ commit }, filters) {
        commit('SET_NETTO_MARK_UPS_FILTERS', filters)
    },
    clearProductGroupFactorsFilters({ commit }) {
        commit('CLEAR_NETTO_MARK_UPS_FILTERS')
    }
}